export default __webpack_public_path__ + "static/media/title2.10a59325.png";